const niches = [
  "Busy professionals 25-45",
  "Frequent travelers",
  "Returning to fitness",
  "Strength-focused",
  "Pre-event prep",
  "Hybrid (lift + run)",
];

export default function NicheCallouts() {
  return (
    <section
      data-testid="niche-section"
      className="relative px-6 md:px-12 lg:px-20 py-10 lg:py-12 border-b border-white/10 bg-[#070707]"
    >
      <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-center gap-x-4 gap-y-3">
        <span className="text-[10px] uppercase tracking-[0.3em] text-white/40 font-semibold mr-2">
          Built for —
        </span>
        {niches.map((n) => (
          <span
            key={n}
            className="text-xs uppercase tracking-[0.2em] font-semibold text-white/70 border border-white/15 hover:border-[#FF1B91] hover:text-[#FF1B91] transition-colors px-3 py-1.5"
          >
            {n}
          </span>
        ))}
      </div>
    </section>
  );
}
